import { memo, type FC } from "react";
import { useTranslation } from "react-i18next";
import CampaignStepCard from "../../../../shared/CampaignStepCard";
import CampaignTextField from "../../../../shared/CampaignTextField";
import ChoiceCard from "../components/ChoiceCard";
import CustomChoicePanel from "../components/CustomChoicePanel";
import { CUSTOM_OPTION } from "../AiCampaignConstants";
import { getSubCampaignOptions } from "../AiCampaignUtils";
import type { AiCampaignForm, UpdateAiCampaignForm } from "../AiCampaignTypes";

const STEP_KEY = "campaignFlow.aiWizard.campaignSubCategory";
const SUB_CATEGORY_NAME_ID = "ai-campaign-sub-category-name";

interface CampaignSubCategoryStepProps {
  form: AiCampaignForm;
  updateForm: UpdateAiCampaignForm;
}

const CampaignSubCategoryStep: FC<CampaignSubCategoryStepProps> = ({ form, updateForm }) => {
  const { t } = useTranslation();
  const options = getSubCampaignOptions(form.campaignType);

  return (
    <CampaignStepCard title={t(`${STEP_KEY}.title`)} subtitle={t(`${STEP_KEY}.subtitle`)}>
      <div className="choice-list" role="radiogroup" aria-label={t(`${STEP_KEY}.title`)}>
        {options.map(option => (
          <ChoiceCard
            key={option.value}
            title={t(option.titleKey)}
            description={option.descKey ? t(option.descKey) : undefined}
            selected={form.subCampaign === option.value}
            onSelect={() => updateForm("subCampaign", option.value)}
          />
        ))}

        <ChoiceCard
          title={t(`${STEP_KEY}.customTitle`)}
          description={t(`${STEP_KEY}.customDescription`)}
          selected={form.subCampaign === CUSTOM_OPTION}
          onSelect={() => updateForm("subCampaign", CUSTOM_OPTION)}
          isCustom
        >
          <CustomChoicePanel
            title={t(`${STEP_KEY}.customPanelTitle`)}
            subtitle={t(`${STEP_KEY}.customPanelSubtitle`)}
          >
            <CampaignTextField
              id={SUB_CATEGORY_NAME_ID}
              label={t("campaignFlow.aiWizard.campaignCategory.subCategoryName")}
              value={form.customSubCampaign}
              onChange={value => updateForm("customSubCampaign", value)}
              placeholder={t("campaignFlow.aiWizard.campaignCategory.subCategoryNamePlaceholder")}
              required
            />
          </CustomChoicePanel>
        </ChoiceCard>
      </div>
    </CampaignStepCard>
  );
};

export default memo(CampaignSubCategoryStep);
